import { ProductCard } from "./product-card"
import type { Product } from "@/lib/api"

interface ProductGridProps {
  products: Product[]
  limit?: number
}

export function ProductGrid({ products, limit = 12 }: ProductGridProps) {
  const safeProducts = products || []
  const displayProducts = safeProducts.slice(0, limit)

  if (safeProducts.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-primary/10 flex items-center justify-center">
          <svg className="w-10 h-10 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            />
          </svg>
        </div>
        <h3 className="text-xl font-semibold mb-2">Mahsulotlar mavjud emas</h3>
        <p className="text-muted-foreground">Admin paneliga kiring va mahsulotlar qo'shing</p>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
      {displayProducts.map((product, index) => (
        <ProductCard key={product.id} product={product} index={index} />
      ))}
    </div>
  )
}
